var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.days,"hide-details":"","dense":"","outlined":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item',_vm._g({attrs:{"v-bind":attrs,"disabled":_vm.isAllowed(item)},on:{"click":function($event){return _vm.changeNumber(item)}}},on),[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n          "+_vm._s(item)+"\n        ")])],1)],1)]}}]),model:{value:(_vm.dayL),callback:function ($$v) {_vm.dayL=$$v},expression:"dayL"}})}
var staticRenderFns = []

export { render, staticRenderFns }